module.exports = __webpack_public_path__ + "img/fuelschge-banner-jp.e53c0c7.png";